
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Engfinity Club' s Mega Event </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                <p>Engfinity Club's Mega Event - a collaborative showcase with GH Raisoni Skill Tech University, Nagpur and GHRCACS, Nagpur, highlighting the latest innovations, student achievements, and technological advancements across the institutions.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity2.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity2.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity3.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity3.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity4.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity4.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity6.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity6.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity7.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity7.avif"
                                alt="GHRCCST" title="GHRCCST">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity8.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity8.avif"
                                alt="GHRCCST" title="GHRCCST">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity9.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity9.avif"
                                alt="GHRCCST" title="GHRCCST">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>